/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-22 13:12:16
 * @LastEditors: 陈钊贤
 * @Description: 接口文档
 * @LastEditTime: 2021-05-24 17:27:58
 */
import { request } from "./api-require";
const API_URL = "/basic-system/v1";
/**
 * 登录
 * @param data
 * @param config
 * @returns
 */
export const sysLogin = (data = {}, config = {}) => {
    return request(API_URL + "/auth/login", data, config);
};
/**
 * 退出登录
 * @param data
 * @param config
 * @returns
 */
export const sysLoginOut = (data = {}, config = {}) => {
    return request(API_URL + "/auth/logout", data, config);
};
/**
 * 获取字典大类信息列表
 * @param data
 * @param config
 * @returns
 */
export const getDictTypeList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/dict/type/list", data, config);
};
/**
 * 获取字典大类信息列表---分页
 * @param data
 * @param config
 * @returns
 */
export const getDictTypeListPage = (data = {}, config = {}) => {
    return request(API_URL + "/dict/type/page", data, config);
};
/**
 * 新增字典大类
 * @param data
 * @param config
 * @returns
 */
export const addDictType = (data = {}, config = {}) => {
    return request(API_URL + "/dict/type/add", data, config);
};
/**
 * 修改字典大类
 * @param data
 * @param config
 * @returns
 */
export const upDictType = (data = {}, config = {}) => {
    return request(API_URL + "/dict/type/upd", data, config);
};
/**
 * 删除字典大类
 * @param data
 * @param config
 * @returns
 */
export const delDictType = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/dict/item/delete", data, config);
};
/**
 * 根据字典小类pkid的操作排序
 * @param data
 * @param config
 * @returns
 */
export const sortDictType = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/dict/item/sort", data, config);
};
/**
 * 获取字典信息指定大类下小类列表
 * @param data
 * @param config
 * @returns
 */
export const getDictItemAll = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/dict/item/list", data, config);
};
/**
 * 分页获取字典信息指定大类下小类列表
 * @param data
 * @param config
 * @returns
 */
export const getDictItemList = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/dict/item/page", data, config);
};
/**
 * 批量获取多个字典信息大类下小类列表集合
 * @param data
 * @param config
 * @returns
 */
export const getDictItemAllList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/dict/item/list_batch", data, config);
};
/**
 * 修改字典小类
 * @param data
 * @param config
 * @returns
 */
export const upDictItem = (data = {}, config = {}) => {
    return request(API_URL + "/dict/item/upd", data, config);
};
/**
 * 新增字典小类
 * @param data
 * @param config
 * @returns
 */
export const addDictItem = (data = {}, config = {}) => {
    return request(API_URL + "/dict/item/add", data, config);
};
/**
 * 删除字典小类
 * @param data
 * @param config
 * @returns
 */
export const delDictItem = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/dict/item/del", data, config);
};
/**
 * 在线用户
 * @param data
 * @param config
 * @returns
 */
export const getOnlineuser = (data = {}, config = {}) => {
    return request(API_URL + "/online_user/page", data, config);
};
/**
 * 强制下线
 * @param data
 * @param config
 * @returns
 */
export const outUser = (data = {}, config = {}) => {
    return request(API_URL + "/online_user/offline", data, config);
};
/**
 * 上传图片
 * @param data
 * @param config
 * @returns
 */
export const uploadImage = (data = {}, config = {}) => {
    return request(API_URL + "/file/upload_image", data, config);
};
/**
 * 上传文件
 * @param data
 * @param config
 * @returns
 */
export const uploadFile = (data = {}, config = {}) => {
    return request(API_URL + "/file/upload", data, config);
};
/**
 * 下载文件
 * @param data
 * @param config
 * @returns
 */
export const downloadFile = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/file/download", data, config);
};
/**
 *  获取运营商
 * @param data
 * @param config
 * @returns
 */
export const getSearchInitData = (data = {}, config = {}) => {
    return request(API_URL + "/alarm/searchInitData", data, config);
};
/**
 * 查看所有运营商列表
 * @param data
 * @param config
 * @returns
 */
export const getAllOperList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/opr/list", data, config);
};
/**
 *  通过运营商获取充电桩
 * @param data
 * @param config
 * @returns
 */
export const getStationByOpr = (data = {}, config = {}) => {
    return request(API_URL + "/alarm/getStationByOpr", data, config);
};
/**
 * 获取省市区
 * @param data
 * @param config
 * @returns
 */
export const getFindAreaList = (data = {}, config = {}) => {
    return request(API_URL + "/region/findAreaList", data, config);
};
/**
 * 发送短信验证码
 * @param data
 * @param config
 * @returns
 */
export const getCodeSms = (data = {}, config = {}) => {
    return request(API_URL + "/vercode/sms_test", data, config);
};
/**
 * 重置密码
 * @param data
 * @param config
 * @returns
 */
export const resetPwd = (data = {}, config = {}) => {
    return request(API_URL + "/opr/user/reset_pwd", data, config);
};
/**
 * 用户
 * @param data
 * @param config
 * @returns
 */
/**
 * 查询所有运营商自定义角色列表
 * @param data
 * @param config
 * @returns
 */
export const getAllRole = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/role/all", data, config);
};
/**
 * 分页查询运营商自定义角色列表
 * @param data
 * @param config
 * @returns
 */
export const getRoleList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/role/page", data, config);
};
/**
 * 保存角色
 * @param data
 * @param config
 * @returns
 */
export const saveRole = (data = {}, config = {}) => {
    return request(API_URL + "/role/save", data, config);
};
/**
 * 删除角色
 * @param data
 * @param config
 * @returns
 */
export const delRole = (data = {}, config = {}) => {
    return request(API_URL + "/role/delete", data, config);
};
/**
 * 保存接口权限
 * @param data
 * @param config
 * @returns
 */
export const saveInterfacePermission = (data = {}, config = {}) => {
    return request(API_URL + "/role/save_interface_permission", data, config);
};
/**
 * 菜单权限列表
 * @param data
 * @param config
 * @returns
 */
export const getPermission = (data = {}, config = {}) => {
    return request(API_URL + "/role/permission", data, config);
};
/**
 * 查询菜单接口权限列表
 * @param data
 * @param config
 * @returns
 */
export const getInterfacePermission = (data = {}, config = {}) => {
    return request(API_URL + "/role/query_interface_permission", data, config);
};
/**
 * 获取角色功能菜单权限
 * @param data
 * @param config
 * @returns
 */
export const getrRolePermission = (data = {}, config = {}) => {
    return request(API_URL + "/user/role_permission", data, config);
};
/**
 * 根据不同用户角色类型 及 所属系统 查询角色列表
 * @param data
 * @param config
 * @returns
 */
export const getRoleSelect = (data = {}, config = {}) => {
    return request(API_URL + "/role/select", data, config);
};
/**
 * 根据userid 获取角色
 * @param data
 * @param config
 * @returns
 */
export const getUserRole = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/role/select", data, config);
};
/**
 * 获取角色详情
 * @param data
 * @param config
 * @returns
 */
export const getRoleDetails = (data = {}, config = {}) => {
    return request(API_URL + "/role/selectOne", data, config);
};
/**
 * 保存角色权限
 * @param data
 * @param config
 * @returns
 */
export const setPermission = (data = {}, config = {}) => {
    return request(API_URL + "/role/set_permission", data, config);
};
/**
 * 查询设备型号列表
 * @param data
 * @param config
 * @returns
 */
export const getModelList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/device/model/list", data, config);
};
/**
 * 分页获取充电桩信息
 * @param data
 * @param config
 * @returns
 */
export const getDeviceOprPage = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/page", data, config);
};
/**
 * 分页查询企业用户统付订单
 * @param data
 * @param config
 * @returns
 */
export const getDeviceOprUpdRecord = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/device/opr/upd_record", data, config);
};
/**
 * 添加充电桩
 * @param data
 * @param config
 * @returns
 */
export const getDeviceOprAdd = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/add", data, config);
};
/**
 * 获取充电桩详情
 * @param data
 * @param config
 * @returns
 */
export const getDeviceOprDetail = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/sys/device/opr/detail", data, config);
};
/**
 * 修改充电桩
 * @param data
 * @param config
 * @returns
 */
export const getDeviceOprUpd = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/upd", data, config);
};
/**
 * 修改充电桩
 * @param data
 * @param config
 * @returns
 */
export const updateDeviceOprStatus = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/sys/device/opr/upd_device_status", data, config);
};
/**
 *  获取警告查询
 * @param data
 * @param config
 * @returns
 */
export const getAlarmQuery = (data = {}, config = {}) => {
    return request(API_URL + "/alarm/query", data, config);
};
/**
 *  获取警告详情
 * @param data
 * @param config
 * @returns
 */
export const getAlarmOrderDetail = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/alarm/queryOrderDetail", data, config);
};
/**
 * 设备厂商--分页获取
 * @param data
 * @param config
 * @returns
 */
export const getManufacturerPage = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/manufacturer/page", data, config);
};
/**
 * 设备厂商--新增
 * @param data
 * @param config
 * @returns
 */
export const addManufacturer = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/manufacturer/add", data, config);
};
/**
 * 设备厂商--修改
 * @param data
 * @param config
 * @returns
 */
export const updManufacturer = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/manufacturer/upd", data, config);
};
/**
 * 设备厂商--删除
 * @param data
 * @param config
 * @returns
 */
export const delManufacturer = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/sys/device/manufacturer/del", data, config);
};
/**
 * 获取用户列表
 * @param data
 * @param config
 * @returns
 */
export const getUserList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/user/page", data, config);
};
/**
 * 修改用户
 * @param data
 * @param config
 * @returns
 */
export const updDataUser = (data = {}, config = {}) => {
    return request(API_URL + "/opr/user/upd", data, config);
};
/**
 * 新增用户
 * @param data
 * @param config
 * @returns
 */
export const addUser = (data = {}, config = {}) => {
    return request(API_URL + "/opr/user/add", data, config);
};
/**
 * 删除用户
 * @param data
 * @param config
 * @returns
 */
export const deleteUser = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/opr/user/del", data, config);
};
/**
 * 删除用户
 * @param data
 * @param config
 * @returns
 */
export const getOprRoleAll = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/role/all", data, config);
};
/**
 * 分页查询运营商自定义角色列表
 * @param data
 * @param config
 * @returns
 */
export const getOprRolePage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/role/page", data, config);
};
/**
 * 新增/修改角色和权限
 * @param data
 * @param config
 * @returns
 */
export const getOprRoleSave = (data = {}, config = {}) => {
    return request(API_URL + "/opr/role/save", data, config);
};
/**
 * 分页查询运营商自定义角色列表
 * @param data
 * @param config
 * @returns
 */
export const getOprRoleDel = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/opr/role/del", data, config);
};
/**
 * 分页查询运营商自定义角色列表
 * @param data
 * @param config
 * @returns
 */
export const getOprRolePermission = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/role/permission", data, config);
};
/**
 * 发送短信验证码
 * @param data
 * @param config
 * @returns
 */
export const vercodeSms = (data = {}, config = {}) => {
    return request(API_URL + "/vercode/sms", data, config);
};
/**
 * 发送短信验证码测试
 * @param data
 * @param config
 * @returns
 */
export const vercodeSmsTest = (data = {}, config = {}) => {
    return request(API_URL + "/vercode/sms_test", data, config);
};
/**
 * 校验短信验证码
 * @param data
 * @param config
 * @returns
 */
export const vercodeSmsValidate = (data = {}, config = {}) => {
    return request(API_URL + "/vercode/sms/validate", data, config);
};
/**
 * 修改密码--重置密码
 * @param data
 * @param config
 * @returns
 */
export const forgetResetPwd = (data = {}, config = {}) => {
    return request(API_URL + "/auth/forget_reset_pwd", data, config);
};
/**
 * 系统更新日志
 * @param data
 * @param config
 * @returns
 */
export const systemUpdateLog = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/system_update/page", data, config);
};
/**
 *  /alarm/count
 * @param data
 * @param config
 * @returns
 */
export const alarmCount = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/summary", data, config);
};
/**
 * 告警概要总值
 * @param data
 * @param config
 * @returns
 */
export const alarmSummary = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/summary", data, config);
};
/**
 * 告警概要trend
 * @param data
 * @param config
 * @returns
 */
export const alarmTrend = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/trend", data, config);
};
/**
 * 告警概要充电站top5
 * @param data
 * @param config
 * @returns
 */
export const alarmStationTop5 = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/station/top5", data, config);
};
/**
 * 告警概要设备top5
 * @param data
 * @param config
 * @returns
 */
export const alarmChargeTop5 = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/charge/top5", data, config);
};
/**
 *  分页获取设备型号列表
 * @param data
 * @param config
 * @returns
 */
export const getModelListPage = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/model/page", data, config);
};
/**
 *  新增设备型号
 * @param data
 * @param config
 * @returns
 */
export const addModelNew = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/model/add", data, config);
};
/**
 *  删除设备型号
 * @param data
 * @param config
 * @returns
 */
export const delOneModel = (data = {}, config = {}) => {
    config.method = "del";
    return request(API_URL + "/sys/device/model/del_batch", data, config);
};
/**
 *  修改设备型号
 * @param data
 * @param config
 * @returns
 */
export const updModelNew = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/model/upd", data, config);
};
/**
 *  分页获取设备清单
 * @param data
 * @param config
 * @returns
 */
export const getDevicePageList = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/page", data, config);
};
/**
 *  获取设备统计
 * @param data
 * @param config
 * @returns
 */
export const getDeviceCout = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/get_cout", data, config);
};
/**
 * 批量删除设备
 * @param data
 * @param config
 * @returns
 */
export const delBatch = (data = {}, config = {}) => {
    config.method = "del";
    return request(API_URL + "/sys/device/del_batch", data, config);
};
/**
 * 批量设备绑定运营商
 * @param data
 * @param config
 * @returns
 */
export const bindOperBatch = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/bind_oper_batch", data, config);
};
/**
 * 批量设备解绑运营商
 * @param data
 * @param config
 * @returns
 */
export const unbindOperBatch = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/unbind_oper_batch", data, config);
};
/**
 * 根据运营商获取充电站
 * @param data
 * @param config
 * @returns
 */
export const getStation = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/alarm/getStationByOpr", data, config);
};
/**
 * 批量设备修改型号
 * @param data
 * @param config
 * @returns
 */
export const upDevModel = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/upd_model_batch", data, config);
};
/**
 *  设备型号批量添加设备
 * @param data
 * @param config
 * @returns
 */
export const pilesAddBatch = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/manage/add_batch", data, config);
};
/**
 *  获取设备型号标配或选配参数列表
 * @param data
 * @param config
 * @returns
 */
export const getModelOptionsList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/device/model/options/list", data, config);
};
/**
 *  获取设备型号详情
 * @param data
 * @param config
 * @returns
 */
export const deviceModelDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/device/model/detail", data, config);
};
/**
 * 设备厂商下拉接口
 * @param data
 * @param config
 * @returns
 */
export const getManufacturerList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/device/manufacturer/get", data, config);
};
/**
 * 修改充电枪信息
 * @param data
 * @param config
 * @returns
 */
export const chargeGunUpd = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/upd_charge_gun", data, config);
};
/**
 * 下发费率--下发电价
 * @param data
 * @param config
 * @returns
 */
export const sendSyncfeeRatecmd = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/sys/device/opr/send_syncfee_ratecmd", data, config);
};
/**
 * 解锁,下发二维码
 * @param data
 * @param config
 * @returns
 */
export const sendPileOperation = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/sys/device/opr/send_pile_operation", data, config);
};
/**
 *  查看用户已关联的站点
 * @param data
 * @param config
 * @returns
 */
export const oprUserStaBound = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/opr/user/sta/bound", data, config);
};
/**
 *  查看用户未关联的站点
 * @param data
 * @param config
 * @returns
 */
export const oprUserStaUnbound = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/opr/user/sta/unbound", data, config);
};
/**
 * 关联站点
 * @param data
 * @param config
 * @returns
 */
export const oprUserOperationSta = (data = {}, config = {}) => {
    return request(API_URL + "/opr/user/operation/sta", data, config);
};
/**
 * 解绑站点
 * @param data
 * @param config
 * @returns
 */
export const unbindSta = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/dev_unbind_sta", data, config);
};
/**
 *  分页查询Sim卡
 * @param data
 * @param config
 * @returns
 */
export const getSIMCardPage = (data = {}, config = {}) => {
    return request(API_URL + "/sys/sim/page", data, config);
};
/**
 *  获取SIM详情
 * @param data
 * @param config
 * @returns
 */
export const SIMCardDetail = (data = {}, config = {}) => {
    return request(API_URL + "/sys/sim/detail", data, config);
};
/**
 *  新增SIM卡
 * @param data
 * @param config
 * @returns
 */
export const SIMCardAdd = (data = {}, config = {}) => {
    return request(API_URL + "/sys/sim/add", data, config);
};
/**
 *  修改SIM卡
 * @param data
 * @param config
 * @returns
 */
export const SIMCardUpd = (data = {}, config = {}) => {
    return request(API_URL + "/sys/sim/update", data, config);
};
/**
 *  统计SIM卡数据
 * @param data
 * @param config
 * @returns
 */
export const SIMTotal = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/sys/sim/total/sim_gird", data, config);
};
/**
 *  导入SIM
 * @param data
 * @param config
 * @returns
 */
export const SIMImport = (data = {}, config = {}) => {
    return request(API_URL + "/sys/sim/import/sim_gird", data, config);
};
/**
 *  查询模板文件信息
 * @param data
 * @param config
 * @returns
 */
export const SIMTemplateSelect = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/template/select", data, config);
};
/**
 *   修改个人密码
 * @param data
 * @param config
 * @returns
 */
export const userResetpwdPersonal = (data = {}, config = {}) => {
    return request(API_URL + "/user/resetpwd/personal", data, config);
};
/**
 *  今日告警
 * @param data
 * @param config
 * @returns
 */
export const getAlarmToday = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/today", data, config);
};
/**
 *  告警概览-汇总数据
 * @param data
 * @param config
 * @returns
 */
export const getAlarmSummary = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/summary", data, config);
};
/**
 *  充电站告警排名top
 * @param data
 * @param config
 * @returns
 */
export const getAlarmStaTop5 = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/sta/top", data, config);
};
/**
 *  告警查询  /basic-system/v1/alarm/query
 * @param data
 * @param config
 * @returns
 */
export const getAlarmQuerys = (data = {}, config = {}) => {
    return request(API_URL + "/alarm/query", data, config);
};
/**
 *  充电桩告警排名top
 * @param data
 * @param config
 * @returns
 */
export const getAlarmPileTop5 = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/pile/top", data, config);
};
/**
 *  获取运营商的登录地址
 * @param data
 * @param config
 * @returns
 */
export const getLoginUrl = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/opr/get_login_url", data, config);
};
/**
 *  获取idemToken的接口
 * @param data
 * @param config
 * @returns
 */
export const getAuthIdempotence = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/auth/idempotence", data, config);
};
/**
 *  获取设备采集扩展属性列表
 * @param data
 * @param config
 * @returns
 */
export const getExpandPropertyList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/device/manage/expand/property/list", data, config);
};
/**
 *  分页获取日志记录
 * @param data
 * @param config
 * @returns
 */
export const getArOperationLogPage = (data = {}, config = {}) => {
    return request(API_URL + "/ar/operation/log/page", data, config);
};
